import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { composeFormData } from '@/utils'

import { PropertyManager, useInvalidatePropertyManagers } from './get-property-managers'

export type UpdatePropertyManagerRequest = {
  avatar?: File
  buildingIds: number[]
  firstName: string
  id: number
  jobTitle?: string
  lastName: string
  // Note: BE column is numeric - the string "null" is the only way to clear it via multipart
  phone?: string
}

export const updatePropertyManager = async ({ id, ...data }: UpdatePropertyManagerRequest) => {
  const response = await authAPI.put<PropertyManager>(
    `/propertyManager/${id}`,
    composeFormData(data),
    { headers: { 'content-type': 'multipart/form-data' } },
  )
  return response.data
}

export const useUpdatePropertyManager = () => {
  const invalidatePropertyManagers = useInvalidatePropertyManagers()

  return useMutation({
    mutationFn: updatePropertyManager,
    onSuccess: invalidatePropertyManagers,
  })
}
